"use strict";
/**
 * User: Shad
 * Date: 9/11/13
 */
/**
 * @mixes SoaModel
 * @class
 */

var SoaModel = require('bunsen/models/SoaModel');
var CurrencyConversionRate = module.exports = SoaModel.extend();

var _ = require('underscore');
var currency = require('bunsen/libraries/currency');

_.extend(CurrencyConversionRate.prototype, {
    canConvert : function (fromCurrency, toCurrency) {
        var mFromCurrency;
        var mToCurrency;
        fromCurrency = currency(fromCurrency);
        toCurrency = currency(toCurrency);
        if (fromCurrency === toCurrency) {
            return true;
        }
        mFromCurrency = currency(this.get('fromCurrency'));
        mToCurrency = currency(this.get('toCurrency'));
        if (!mFromCurrency || !mToCurrency) {
            return false;
        }
        return (
            (mFromCurrency === fromCurrency && mToCurrency === toCurrency) ||
            (mToCurrency === fromCurrency && mFromCurrency === toCurrency)
        );
    },
    convert : function (fromAmount, fromCurrency, toCurrency, precision) {
        var rate = parseFloat(this.get('rate'));
        if (!this.canConvert(fromCurrency, toCurrency)) {
            return void 0;
        }
        precision = precision === void 0 ? 2 : precision;
        fromCurrency = currency(fromCurrency);
        toCurrency = currency(toCurrency);
        if (fromCurrency === toCurrency) {
            return fromAmount;
        }
        if (fromCurrency !== currency(this.get('fromCurrency'))) {
            rate = 1 / rate;
        }
        return Math.round(fromAmount * rate * Math.pow(10, precision)) / Math.pow(10, precision);
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/CurrencyConversionRate.js
// module id = 2036
// module chunks = 62